<script>
import axios from '@/utils/axios';

export default {
    inject: ['setLoading'],
    data() {
        return {
            errors: {},
            id: '',
            sales_order_id: null,
            challan_number: '',
            id: '',
            challan_number: '',
            client_type: 'Engineer',
            recipient_type: 'App\\Models\\Engineer',
            recipient_id: null,
            warehouse_id: null,
            dispatch_date: '',
            reference_no: '',
            transporter_name: '',
            vehicle_no: '',
            purpose: '',
            status: '',
            subtotal: 0,
            tax_amount: 0,
            total: 0,
            tax_breakdown: {},

            // Dropdown data
            recipients: [],
            warehouses: [],
            taxes: [],
            products: [],
            brands: [],
            item_groups: [],
            // Items
            items: [
            { brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null }
            ],

            // For view detail
            detail: null,
            docModal: {
            show: false,
            document: null,
            documentName: '',
            },
            module_url: 'inventory/delivery-challans',
            id: '',
            sales_order_id: null,
        };
    },

    computed: {
  isStorePerson() {
    return !!(this.auth?.store_person?.id);
  }
},

    methods: {

      async getItemGroups() {
  try {
    const res = await axios.get('/item-groups', { params: { inventory_type: 'finish' } });
    this.item_groups = res.data.data || [];
  } catch (error) {
    this.$swalToast(error.message, 'error');
  }
},

async onCategorySelect(index, itemGroupId) {
  const row = this.items[index];
  row.item_group_id = itemGroupId;
  row.item_name = null;
  row.unique_items = [];
  row.brand_id = null;
  row.item_id = null;
  row.items_list = [];
  row.name = '';
  row.unit_price = 0;
  row.tax_id = null;

  if (!itemGroupId) return;

  try {
    const response = await axios.get('/items/unique-dropdown', {
      params: { item_group_id: itemGroupId, inventory_type: 'finish' }
    });
    row.unique_items = response.data.data || [];
  } catch (error) {
    this.$swalToast('Failed to load items for selected category', 'error');
  }
},

async onUniqueItemSelect(index, itemName) {
  const row = this.items[index];
  row.item_name = itemName;
  row.brand_id = null;
  row.item_id = null;
  row.items_list = [];
  row.name = '';
  row.unit_price = 0;
  row.tax_id = null;

  if (!itemName) return;

  try {
    const response = await axios.get('/items/item-wise-brand', {
      params: { item_name: itemName, inventory_type: 'finish' }
    });
    row.items_list = response.data.data || [];
  } catch (error) {
    this.$swalToast('Failed to load brands for selected item', 'error');
  }
},

onBrandSelect(index, selectedItem) {
  const row = this.items[index];
  if (!selectedItem) {
    row.item_id = null;
    row.brand_id = null;
    row.name = '';
    row.unit_price = 0;
    row.tax_id = null;
    return;
  }

  row.item_id = selectedItem.id;
  row.brand_id = selectedItem.brand_id;
  row.name = selectedItem.name || '';
  row.unit_price = parseFloat(selectedItem.price || 0);
  row.tax_id = selectedItem.tax_id || null;
},

//  onItemSelect(index, itemId) {
//   const row = this.items[index];
//   if (!itemId) {
//     row.item_id = null;
//     row.name = '';
//     row.quantity = 1;
//     row.unit_price = 0;
//     row.tax_id = null;
//     return;
//   }
//   const product = row.items_list.find(p => p.id === itemId);
//   if (product) {
//     row.unit_price = parseFloat(product.price || 0);
//     row.name = product.name || '';
//     row.tax_id = product.tax_id || null;
//   }
// },

   async loadDropdowns(skipRecipients = false) {
    try {
        const [warehouseRes, taxRes, brandRes] = await Promise.all([
            axios.get('/inventory/warehouses/dropdown'),
            axios.get('/taxes'),
            axios.get('/brands/dropdown'),
        ]);

        const getArray = (res) => {
            const d = res.data.data;
            return Array.isArray(d) ? d : (d?.data || []);
        };

        this.warehouses = getArray(warehouseRes);
        this.taxes = getArray(taxRes);
        this.brands = brandRes.data.data || [];

        await this.getItemGroups();   // 👈 NEW

        if (!skipRecipients) {
            await this.loadRecipients(this.client_type);
        }
    } catch (error) {
        console.log('Dropdown load error:', error.message);
    }
},

async loadRecipients(type) {
    try {
        const urlMap = {
            'Lead': '/leads/dropdown',
            'Engineer': '/engineers/dropdown',
            'Customer': '/customers/dropdown-for-dc',
            'WorkOrder': '/work-orders/dropdown',
            'SalesExecutive': '/sales-executives/dropdown',
            'InternalConsumption': '/internal-consumptions/dropdown',
        };

        const url = urlMap[type];
        if (!url) return;

        const res = await axios.get(url);
        const d = res.data.data;
        this.recipients = Array.isArray(d) ? d : (d?.data || []);
    } catch (error) {
        console.log('Recipients load error:', error.message);
    }
},

        onClientTypeChange() {
    this.recipient_id = null;
    this.recipients = [];

    const typeMap = {
        'Lead': 'App\\Models\\Lead',
        'Engineer': 'App\\Models\\Engineer',
        'Customer': 'App\\Models\\Customer',
        'WorkOrder': 'App\\Models\\WorkOrder',
        'SalesExecutive': 'App\\Models\\SalesExecutive',
        'InternalConsumption': 'App\\Models\\InternalConsumption',
    };
    this.recipient_type = typeMap[this.client_type] || 'App\\Models\\Engineer';

    this.loadRecipients(this.client_type);
},

        getRecipientLabel(row) {

            if (this.client_type === 'Lead') {
             return row.name || '-';
            }   if (this.client_type === 'Engineer') {
                return row.user?.name || row.name || '-';
            } else if (this.client_type === 'Customer') {
                return row.company_name || row.name || '-';
            } else if (this.client_type === 'WorkOrder') {
                return row.name || '-';  
            } else if (this.client_type === 'SalesExecutive') {
                return row.user?.name || row.name || '-';
           }  else if (this.client_type === 'InternalConsumption') {
                return row.name || '-';
            }
        },

async createFromSalesOrder(so) {
  this.resetForm();

  const partyTypeToClientType = {
    'App\\Models\\Lead': 'Lead',
    'App\\Models\\Customer': 'Customer',
    'App\\Models\\WorkOrder': 'WorkOrder',
    'App\\Models\\SalesExecutive': 'SalesExecutive',
    'App\\Models\\InternalConsumption': 'InternalConsumption',
  };

  this.client_type = partyTypeToClientType[so.party_type] || 'WorkOrder';
  this.recipient_type = so.party_type || 'App\\Models\\WorkOrder';

  await this.loadDropdowns(true);
  await this.loadRecipients(this.client_type);

  this.sales_order_id = so.id;
  this.recipient_id = so.party_id || so.work_order_id || null;

  if (so.party && this.client_type !== 'WorkOrder' && !this.recipients.some(r => r.id === so.party.id)) {
    this.recipients = [so.party, ...this.recipients];
  }

  this.dispatch_date = new Date().toISOString().substring(0, 10);

  const dispatchItems = so.store_dispatch_lists || [];
  if (dispatchItems.length) {
    this.items = [];
    for (const entry of dispatchItems) {
      const embeddedItem = entry.item || null;

      // Full item details (item_group_id, price, tax_id, calculation_type) yahan se aayenge
      let fullItem = null;
      try {
        const res = await axios.get(`/items/${entry.item_id}`);
        fullItem = res.data.data;
      } catch (e) {
        fullItem = null;
      }

      // Merge: fullItem se base fields, embeddedItem se brand (jo reliably aata hai)
      const merged = {
        ...(fullItem || {}),
        brand: embeddedItem?.brand || fullItem?.brand || null,
        brand_id: embeddedItem?.brand_id || fullItem?.brand_id || null,
      };

      const itemGroupId = merged.item_group_id || null;

      // Category select hone par jo unique_items dropdown chahiye, wo bhi load karo
      let uniqueItems = [];
      if (itemGroupId) {
        try {
          const uRes = await axios.get('/items/unique-dropdown', {
            params: { item_group_id: itemGroupId, inventory_type: 'finish' }
          });
          uniqueItems = uRes.data.data || [];
        } catch (e) {
          console.log('Unique items load error:', e.message);
        }
      }

      this.items.push({
        item_group_id: itemGroupId,
        item_name: merged.name || embeddedItem?.name || null,
        unique_items: uniqueItems,
        brand_id: merged.brand_id,
        item_id: entry.item_id,
        items_list: [merged],
        name: merged.name || embeddedItem?.name || '',
        quantity: parseFloat(entry.quantity) || 1,
        unit_price: parseFloat(merged.price || 0),
        tax_id: merged.tax_id || null,
      });
    }
  }
},

        async openChallan(row = null) {
    this.resetForm();

    if (row !== null) {
        if (row.recipient_type === 'App\\Models\\Customer') {
            this.client_type = 'Customer';
            this.recipient_type = 'App\\Models\\Customer';
        } else if (row.recipient_type === 'App\\Models\\WorkOrder') {
            this.client_type = 'WorkOrder';
            this.recipient_type = 'App\\Models\\WorkOrder';
        } else if (row.recipient_type === 'App\\Models\\SalesExecutive') {
            this.client_type = 'SalesExecutive';
            this.recipient_type = 'App\\Models\\SalesExecutive';
        } else if (row.recipient_type === 'App\\Models\\InternalConsumption') {
            this.client_type = 'InternalConsumption';
            this.recipient_type = 'App\\Models\\InternalConsumption';
        } else {
            this.client_type = 'Engineer';
            this.recipient_type = 'App\\Models\\Engineer';
        }

        await this.loadDropdowns();

        this.id = row.id;
        this.challan_number = row.challan_number;
        this.recipient_id = row.recipient_id;
        this.warehouse_id = row.warehouse_id;
        this.dispatch_date = row.dispatch_date ? row.dispatch_date.substring(0, 10) : '';
        this.reference_no = row.reference_no;
        this.transporter_name = row.transporter_name;
        this.vehicle_no = row.vehicle_no;
        this.purpose = row.purpose;
        this.status = row.status;

        if (row.challan_items && row.challan_items.length) {
        this.items = row.challan_items.map(item => ({
            item_group_id: item.item?.item_group_id || null,
            item_name: item.item?.name || item.name || null,
            unique_items: [],
            brand_id: item.item?.brand_id || null,
            item_id: item.item_id,
            items_list: [],
            name: item.name,
            quantity: item.quantity,
            unit_price: parseFloat(item.unit_price),
            tax_id: item.tax_id,
        }));

        for (let i = 0; i < this.items.length; i++) {
            const row = this.items[i];

            if (row.item_group_id) {
                try {
                    const res = await axios.get('/items/unique-dropdown', {
                        params: { item_group_id: row.item_group_id, inventory_type: 'finish' }
                    });
                    row.unique_items = res.data.data || [];
                } catch (e) {
                    console.log('Unique items load error:', e.message);
                }
            }

            if (row.item_name) {
                try {
                    const res = await axios.get('/items/item-wise-brand', {
                        params: { item_name: row.item_name, inventory_type: 'finish' }
                    });
                    row.items_list = res.data.data || [];
                } catch (e) {
                    console.log('Brand items load error:', e.message);
                }
            }
        }
    }

    } else {
        await this.loadDropdowns();
    }
},
addItem() {
    this.items.push({ item_group_id: null, item_name: null, unique_items: [], brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null });
},

        removeItem(index) {
            if (this.items.length > 1) {
                this.items.splice(index, 1);
            }
        },

async saveChallan() {
  this.errors = {};

  if (!this.recipient_id) {
    this.$swalToast('Please select a recipient', 'error');
    return;
  }
  if (!this.warehouse_id) {
    this.$swalToast('Please select a warehouse', 'error');
    return;
  }
  if (!this.dispatch_date) {
    this.$swalToast('Please select dispatch date', 'error');
    return;
  }
  for (let i = 0; i < this.items.length; i++) {
    if (!this.items[i].item_id) {
      this.$swalToast(`Please select an item for row ${i + 1}`, 'error');
      return;
    }
    // if (!this.items[i].quantity || this.items[i].quantity < 1) {
    //   this.$swalToast(`Please enter valid quantity for row ${i + 1}`, 'error');
    //   return;
    // }
  }

if (!this.docModal.document) {
    this.$swalToast('Please upload at least one document.', 'error');
    return;
}

  this.setLoading(true);
  try {
    const formData = new FormData();
    formData.append('recipient_type', this.recipient_type);
    formData.append('recipient_id', this.recipient_id);
    formData.append('warehouse_id', this.warehouse_id);
    formData.append('dispatch_date', this.dispatch_date);
    formData.append('reference_no', this.reference_no || '');
    formData.append('transporter_name', this.transporter_name || '');
    formData.append('vehicle_no', this.vehicle_no || '');
    formData.append('purpose', this.purpose || '');
    formData.append('document', this.docModal.document);

    if (this.id) {
      formData.append('id', this.id);
    }


    if (this.sales_order_id) {
      formData.append('sales_order_id', this.sales_order_id);
    }

    this.items.forEach((item, index) => {
      const product = item.items_list.find(p => p.id === item.item_id);
      formData.append(`items[${index}][item_id]`, item.item_id || '');
      formData.append(`items[${index}][name]`, product?.name || item.name || '');
      formData.append(`items[${index}][quantity]`, item.quantity);
      formData.append(`items[${index}][unit_price]`, item.unit_price);
      formData.append(`items[${index}][tax_id]`, item.tax_id || '');
    });

    const response = await axios.post(`/${this.module_url}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.resetForm();
    this.$closeModal('challan_modal');
  } catch (error) {
    if (error.type == 'validation' && typeof error.errors === 'object') {
      this.errors = error.errors;
      this.$openModal('challan_modal');
    } else if (error.type == 'validation' && typeof error.errors === 'string') {
      this.$swalToast(error.errors, 'error');
    } else {
      this.$swalToast(error.message, 'error');
    }
  } finally {
    this.setLoading(false);
  }
},

handleDocChange(event) {
  const file = event.target.files[0];
  if (file) {
    this.docModal.document = file;
    this.docModal.documentName = file.name;
  }
},

removeDoc() {
  this.docModal.document = null;
  this.docModal.documentName = '';
  if (this.$refs.docFileInputInline) {
    this.$refs.docFileInputInline.value = '';
  }
},

closeDocModal() {
  this.docModal.show = false;
  this.$openModal('challan_modal');
},

submitDocModal() {
  if (!this.docModal.document) {
    this.$swalToast('Please upload a document.', 'error');
    return;
  }
  this.docModal.show = false;
  this.saveChallan();
},

        async viewChallan(id) {
            this.setLoading(true);
            try {
                const response = await axios.get(`/${this.module_url}/${id}`);
                this.detail = response.data.data;
            } catch (error) {
                this.$swalToast(error.message, 'error');
            } finally {
                this.setLoading(false);
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return '-';
            const d = new Date(dateStr);
            return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
        },

        formatCurrency(val) {
            return parseFloat(val || 0).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },

        statusBadge(status) {
            const map = {
                draft: 'bg-warning-subtle text-warning',
                dispatched: 'bg-success-subtle text-success',
                received: 'bg-info-subtle text-info',
                cancelled: 'bg-danger-subtle text-danger',
            };
            return map[status] || 'bg-secondary-subtle text-secondary';
        },

        resetForm() {
            this.id = '';
            this.sales_order_id = null;
            this.challan_number = '';
            this.client_type = 'Engineer';
            this.recipient_type = 'App\\Models\\Engineer';
            this.recipient_id = null;
            this.warehouse_id = null;
            this.dispatch_date = '';
            this.reference_no = '';
            this.transporter_name = '';
            this.vehicle_no = '';
            this.purpose = '';
            this.status = '';
            this.subtotal = 0;
            this.tax_amount = 0;
            this.total = 0;
            this.errors = {};
            this.recipients = [];
            this.docModal = { show: false, document: null, documentName: '' };
            this.items = [{ brand_id: null, item_id: null, items_list: [], name: '', quantity: 1, unit_price: 0, tax_id: null }];
        },

    },
};
</script>

<style scoped>
.qm-main {
  flex: 1; display: flex; flex-direction: column; overflow: hidden;
  background: #f1f5f9;
}
.qm-topbar {
  background: #fff; border-bottom: 1px solid #e2e8f0;
  padding: 12px 22px;
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.qm-page-title { font-size: 14px; font-weight: 700; color: #0f172a; }
.qm-page-sub { font-size: 11px; color: #94a3b8; }
.qm-close-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #f1f5f9; border: 1px solid #ef4444;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 13px; transition: all .15s;
  color: #ef4444;
}
.qm-close-btn:hover { background: #fee2e2; border-color: #fca5a5; color: #ef4444; }
.qm-body {
  flex: 1; overflow-y: auto; padding: 18px 22px;
  scrollbar-width: thin; scrollbar-color: #cbd5e1 transparent;
}
.qm-body::-webkit-scrollbar { width: 4px; }
.qm-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
.qm-card {
  background: #fff; border: 1px solid #e2e8f0;
  border-radius: 12px; margin-bottom: 14px; overflow: visible;
}
.qm-card-head {
  display: flex; align-items: center; gap: 9px;
  padding: 10px 16px; background: #f8fafc;
  border-bottom: 1px solid #e8edf3;
}
.qm-card-icon {
  width: 24px; height: 24px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; flex-shrink: 0;
}
.qm-card-title { font-size: 12px; font-weight: 700; color: #0f172a; letter-spacing: .1px; }
.qm-card-body { padding: 14px 16px; }
.qm-label {
  font-size: 11px; font-weight: 600; color: #475569;
  margin-bottom: 4px; display: block;
}
.qm-input, .qm-select {
  width: 100%; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 11px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; height: 35px;
  transition: border-color .15s, box-shadow .15s;
}
.qm-input:focus, .qm-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1);
}
.qm-err-msg {
  font-size: 10.5px; color: #f43f5e; margin-top: 3px;
  display: flex; align-items: center; gap: 3px;
}
.qm-item-card {
  background: #fff; border: 1.5px solid #e8edf3;
  border-radius: 10px; padding: 14px 14px 10px;
  margin-bottom: 10px; position: relative;
  transition: border-color .15s, box-shadow .15s;
}
.qm-item-card:hover { border-color: #bfdbfe; box-shadow: 0 2px 10px rgba(59,130,246,.07); }
.qm-item-num {
  position: absolute; top: -9px; left: 14px;
  width: 19px; height: 19px; background: #3b82f6; color: #fff;
  border-radius: 50%; font-size: 9px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
}
.qm-remove-btn {
  width: 30px; height: 30px; border-radius: 7px;
  background: #fff0f3; border: 1.5px solid #fecdd3;
  color: #f43f5e; font-size: 13px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.qm-remove-btn:hover { background: #f43f5e; border-color: #f43f5e; color: #fff; }
.qm-add-item-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 14px; background: #eff6ff;
  border: 1.5px dashed #93c5fd; border-radius: 8px;
  color: #2563eb; font-size: 11.5px; font-weight: 600;
  cursor: pointer; transition: all .15s;
}
.qm-add-item-btn:hover { background: #dbeafe; border-color: #3b82f6; }
.qm-footer {
  background: #fff; border-top: 1px solid #e2e8f0;
  padding: 11px 22px; display: flex; align-items: center; gap: 8px; flex-shrink: 0; flex-wrap: wrap;
}
.qm-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 7px 15px; border-radius: 8px; font-size: 12px;
  font-weight: 600; cursor: pointer; border: 1.5px solid transparent;
  transition: all .15s; text-decoration: none; white-space: nowrap;
}
.qm-btn-primary {
  background: linear-gradient(135deg,#2563eb,#3b82f6);
  color: #fff; border-color: #2563eb;
  box-shadow: 0 2px 8px rgba(37,99,235,.25);
}
.qm-btn-primary:hover { background: linear-gradient(135deg,#1d4ed8,#2563eb); }
.qm-btn-ghost { background: #f8fafc; color: #475569; border-color: #e2e8f0; }
.qm-btn-ghost:hover { background: #f1f5f9; }
:deep(.vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important; border-radius: 8px !important;
  min-height: 35px !important; padding: 0 8px !important;
  transition: border-color .15s, box-shadow .15s !important;
}
:deep(.vs__dropdown-toggle:focus-within) {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 3px rgba(59,130,246,.1) !important;
}
:deep(.vs__search) { font-size: 12.5px !important; color: #1e293b !important; }
:deep(.vs__selected) {
  font-size: 12px !important; color: #1e293b !important;
  background: #eff6ff !important; border: 1px solid #bfdbfe !important;
  border-radius: 5px !important;
}
</style>

<template>

<!-- ═══════════════════════════════════════════════
     CREATE / EDIT DELIVERY CHALLAN — FULLSCREEN
═══════════════════════════════════════════════ -->
<div class="modal fade" id="challan_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" style="margin:0;">
    <div class="modal-content border-0 h-100" style="border-radius:0;">

      <div class="qm-main">

        <!-- Topbar -->
        <div class="qm-topbar">
          <div>
            <div class="qm-page-title">{{ id ? 'Edit Delivery Challan' : 'Create Delivery Challan' }}</div>
            <div class="qm-page-sub">{{ id ? 'Update challan details below' : 'Fill in the details to create a new delivery challan' }}</div>
          </div>
          <button type="button" class="qm-close-btn" data-bs-dismiss="modal">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <!-- Form Body -->
        <form @submit.prevent="saveChallan" class="d-flex flex-column" style="flex:1;overflow:hidden;">
          <div class="qm-body">

            <!-- ── 1. Challan Information ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#fff0f0;"><i class="ti ti-truck-delivery" style="color:#e84040;"></i></div>
                <span class="qm-card-title">Challan Information</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">

                  <div class="col-md-3">
                    <label class="qm-label">Client Type <span style="color:#f43f5e;">*</span></label>
                    <vue-select
                      :options="[
                        { label: 'Lead', value: 'Lead' },
                        { label: 'Engineer', value: 'Engineer' },
                        { label: 'Customer', value: 'Customer' },
                        { label: 'Work Order', value: 'WorkOrder' },
                        { label: 'Sales Executive', value: 'SalesExecutive' },
                        { label: 'Internal Consumption', value: 'InternalConsumption' }
                      ]"

                      label="label"
                      :reduce="o => o.value"
                      v-model="client_type"
                      @update:modelValue="onClientTypeChange"
                      placeholder="Select Client Type"
                    />
                  </div>

                  <div class="col-md-3">
                    <label class="qm-label">
                      {{ client_type === 'Lead' ? 'Lead' : client_type === 'Engineer' ? 'Engineer' : client_type === 'WorkOrder' ? 'Work Order' : client_type === 'SalesExecutive' ? 'Sales Executive' : client_type === 'InternalConsumption' ? 'Internal Consumption' : 'Customer' }}
                      <span style="color:#f43f5e;">*</span>
                    </label>
                    <vue-select
                      :options="recipients"
                      :get-option-label="getRecipientLabel"
                      v-model="recipient_id"
                      :reduce="r => r.id"
                      :placeholder="'Select ' + client_type"
                    />
                    <div v-if="errors.recipient_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.recipient_id[0] }}</div>
                  </div>

                  <div class="col-md-3">
                    <label class="qm-label">Warehouse <span style="color:#f43f5e;">*</span></label>
                    <vue-select :options="warehouses" label="name" v-model="warehouse_id" :reduce="w => w.id" placeholder="Select Warehouse" />
                    <div v-if="errors.warehouse_id" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.warehouse_id[0] }}</div>
                  </div>

                  <div class="col-md-3">
                    <label class="qm-label">Dispatch Date <span style="color:#f43f5e;">*</span></label>
                    <input type="date" class="qm-input" v-model="dispatch_date" />
                    <div v-if="errors.dispatch_date" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.dispatch_date[0] }}</div>
                  </div>

                  <div class="col-md-3">
                    <label class="qm-label">Reference No</label>
                    <input type="text" class="qm-input" v-model="reference_no" placeholder="Enter reference no" />
                    <div v-if="errors.reference_no" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.reference_no[0] }}</div>
                  </div>

                  <div class="col-md-3">
                    <label class="qm-label">Purpose</label>
                    <input type="text" class="qm-input" v-model="purpose" placeholder="Enter purpose" />
                    <div v-if="errors.purpose" class="qm-err-msg"><i class="ti ti-alert-circle"></i>{{ errors.purpose[0] }}</div>
                  </div>

                </div>
              </div>
            </div>

            <!-- ── 2. Transport Details ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#eff6ff;"><i class="ti ti-truck" style="color:#3b82f6;"></i></div>
                <span class="qm-card-title">Transport Details</span>
              </div>
              <div class="qm-card-body">
                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="qm-label">Transporter Name</label>
                    <input type="text" class="qm-input" v-model="transporter_name" placeholder="Enter transporter name" />
                  </div>
                  <div class="col-md-4">
                    <label class="qm-label">Vehicle No</label>
                    <input type="text" class="qm-input" v-model="vehicle_no" placeholder="Enter vehicle number" />
                  </div>
                </div>
              </div>
            </div>

            <!-- ── Challan Summary ── -->
            <div class="qm-card" v-if="recipient_id || warehouse_id || dispatch_date">
            <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#f0fdf4;"><i class="ti ti-clipboard-check" style="color:#22c55e;"></i></div>
                <span class="qm-card-title">Challan Summary</span>
            </div>
            <div class="qm-card-body" style="padding:12px 16px;">
                <div style="display:flex;flex-wrap:wrap;gap:10px;">
                <!-- Type -->
                <div style="flex:1;min-width:120px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fff0f0;border-radius:6px;">
                    <i class="ti ti-users" style="font-size:14px;color:#e84040;"></i>
                    </span>
                    <div>
                    <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Type</span>
                    <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ client_type }}</span>
                    </div>
                </div>
                <!-- Recipient -->
                <div style="flex:1.5;min-width:150px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#eef6ff;border-radius:6px;">
                    <i class="ti ti-user-circle" style="font-size:14px;color:#3b82f6;"></i>
                    </span>
                    <div style="overflow:hidden;">
                    <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Recipient</span>
                    <span style="font-size:13px;font-weight:600;color:#1a1d23;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;">
                        {{ recipients.find(r => r.id === recipient_id) ? getRecipientLabel(recipients.find(r => r.id === recipient_id)) : '-' }}
                    </span>
                    </div>
                </div>
                <!-- Warehouse -->
                <div style="flex:1;min-width:130px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#f0faf0;border-radius:6px;">
                    <i class="ti ti-building-warehouse" style="font-size:14px;color:#22c55e;"></i>
                    </span>
                    <div>
                    <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Warehouse</span>
                    <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ warehouses.find(w => w.id === warehouse_id)?.name || '-' }}</span>
                    </div>
                </div>
                <!-- Date -->
                <div style="flex:1;min-width:120px;background:#f8fafc;border:1px solid #eef0f6;border-radius:8px;padding:10px 12px;display:flex;align-items:center;gap:8px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;background:#fef9ee;border-radius:6px;">
                    <i class="ti ti-calendar" style="font-size:14px;color:#f59e0b;"></i>
                    </span>
                    <div>
                    <span style="font-size:10px;color:#9e9e9e;text-transform:uppercase;letter-spacing:0.4px;display:block;">Dispatch Date</span>
                    <span style="font-size:13px;font-weight:600;color:#1a1d23;">{{ dispatch_date || '-' }}</span>
                    </div>
                </div>
                </div>
            </div>
            </div>

            <!-- ── 3. Challan Items ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#fffbeb;"><i class="ti ti-list-details" style="color:#f59e0b;"></i></div>
                <span class="qm-card-title">Challan Items</span>
                <button v-if="!isStorePerson" type="button" class="qm-add-item-btn ms-auto" @click="addItem">
                  <i class="ti ti-plus"></i> Add Item
                </button>
              </div>
              <div class="qm-card-body">

                <div v-if="errors.items" class="qm-err-msg mb-3">
                  <i class="ti ti-alert-circle"></i>{{ errors.items[0] }}
                </div>

                <div v-for="(item, index) in items" :key="index" class="qm-item-card">
                  <div class="qm-item-num">{{ index + 1 }}</div>
                  <div class="row g-2 align-items-end">

                    <div class="col-md-3">
                        <label class="qm-label">Category</label>
                        <vue-select
                          :options="item_groups"
                          label="name"
                          :reduce="g => g.id"
                          v-model="item.item_group_id"
                          placeholder="Select Category"
                          @update:modelValue="val => onCategorySelect(index, val)"
                          :disabled="isStorePerson"
                        />
                      </div>

                      <div class="col-md-3">
                        <label class="qm-label">Item <span style="color:#f43f5e;">*</span></label>
                       <vue-select
                        :options="item.unique_items"
                        label="name"
                        v-model="item.item_name"
                        :reduce="i => i.name"
                        placeholder="Select Item"
                        :disabled="!item.item_group_id || isStorePerson"
                        @update:modelValue="val => onUniqueItemSelect(index, val)"
                      />
                        <div v-if="errors[`items.${index}.item_id`]" class="qm-err-msg">
                          <i class="ti ti-alert-circle"></i>{{ errors[`items.${index}.item_id`][0] }}
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label class="qm-label">Brand</label>
                       <vue-select
                          :options="item.items_list"
                          :get-option-label="opt => opt.brand?.name || 'N/A'"
                          :model-value="item.items_list.find(opt => opt.id === item.item_id) || null"
                          placeholder="Select Brand"
                          :disabled="!item.item_name || isStorePerson"
                          @update:modelValue="val => onBrandSelect(index, val)"
                        />
                      </div>

                    <div class="col-md-1">
                      <label class="qm-label">Qty</label>
                      <input type="number" class="qm-input" v-model="item.quantity" min="0" />
                    </div>

                    <div class="col-md-2">
                      <label class="qm-label">Unit Price</label>
                      <input type="number" class="qm-input" v-model="item.unit_price" min="0" step="0.01"  :disabled="isStorePerson"/>
                    </div>

                    <div class="col-md-1">
                      <label class="qm-label">Tax</label>
                     <vue-select :options="taxes" label="name" v-model="item.tax_id" :reduce="t => t.id" placeholder="Tax" :disabled="isStorePerson" />
                    </div>

                    <div class="col-md-1 d-flex align-items-end">
                     <button v-if="items.length > 1 && !isStorePerson" type="button" class="qm-remove-btn" @click="removeItem(index)">
                        <i class="ti ti-trash"></i>
                      </button>
                    </div>

                  </div>
                </div>

                <div v-if="!items.length" style="text-align:center;padding:28px;color:#94a3b8;">
                  <i class="ti ti-inbox" style="font-size:28px;display:block;margin-bottom:6px;opacity:.4;"></i>
                  No items added yet.
                </div>

              </div>
            </div>

            <!-- ── 4. Documents ── -->
            <div class="qm-card">
              <div class="qm-card-head">
                <div class="qm-card-icon" style="background:#faf5ff;"><i class="ti ti-file-upload" style="color:#8b5cf6;"></i></div>
                <span class="qm-card-title">Documents <span style="color:#f43f5e;font-size:10px;margin-left:4px;">* At least 1 required</span></span>
              </div>
              <div class="qm-card-body">

                <div v-if="!docModal.documentName"
                  style="border:2px dashed #e2e8f0;border-radius:10px;padding:28px;text-align:center;cursor:pointer;background:#fafafa;transition:all .15s;"
                  @click="$refs.docFileInputInline.click()"
                  @dragover.prevent
                  @drop.prevent="handleDocChange({ target: { files: $event.dataTransfer.files } })"
                  @mouseenter="$event.target.style.borderColor='#3b82f6'"
                  @mouseleave="$event.target.style.borderColor='#e2e8f0'">
                  <i class="ti ti-cloud-upload" style="font-size:32px;color:#94a3b8;display:block;margin-bottom:8px;"></i>
                  <div style="font-size:13px;font-weight:600;color:#475569;">Click to upload or drag & drop</div>
                  <div style="font-size:11px;color:#94a3b8;margin-top:4px;">PDF, JPG, PNG (Max 5MB)</div>
                  <input type="file" ref="docFileInputInline" style="display:none;" accept=".pdf,.jpg,.jpeg,.png" @change="handleDocChange" />
                </div>

                <div v-else
                  style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border:1.5px solid #e2e8f0;border-radius:10px;background:#f8fafc;">
                  <div style="display:flex;align-items:center;gap:10px;">
                    <div style="width:36px;height:36px;background:#eff6ff;border-radius:8px;display:flex;align-items:center;justify-content:center;">
                      <i class="ti ti-file-filled" style="font-size:17px;color:#3b82f6;"></i>
                    </div>
                    <div>
                      <div style="font-size:13px;font-weight:600;color:#1e293b;">{{ docModal.documentName }}</div>
                      <div style="font-size:11px;color:#94a3b8;">Ready to upload</div>
                    </div>
                  </div>
                  <button type="button" class="qm-remove-btn" @click="removeDoc">
                    <i class="ti ti-trash"></i>
                  </button>
                </div>

              </div>
            </div>

          </div><!-- /qm-body -->

          <!-- Footer -->
          <div class="qm-footer">
            <button v-if="!isStorePerson" type="button" class="qm-btn qm-btn-ghost me-auto" @click="addItem">
              <i class="ti ti-plus"></i> Add Item
            </button>
            <button type="button" class="qm-btn qm-btn-ghost" data-bs-dismiss="modal">
              Cancel
            </button>
            <button type="submit" class="qm-btn qm-btn-primary">
              <i class="ti ti-device-floppy"></i> {{ id ? 'Update Challan' : 'Save Challan' }}
            </button>
          </div>

        </form>
      </div><!-- /qm-main -->

    </div>
  </div>
</div>
<!-- /Delivery Challan Modal -->


<!-- ===== VIEW DETAIL MODAL ===== -->
<div class="modal fade" id="challan_detail_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content" style="border:none;border-radius:14px;overflow:hidden;">

            <div class="modal-header" style="background:#f8f9fb;border-bottom:1px solid #f0f1f5;padding:16px 20px;">
                <div style="display:flex;align-items:center;gap:10px;">
                    <span style="display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;background:#fff0f0;border-radius:8px;">
                        <i class="ti ti-file-description" style="font-size:17px;color:#e84040;"></i>
                    </span>
                    <h4 class="modal-title" style="font-size:15px;font-weight:600;margin:0;color:#1a1d23;">
                        {{ detail?.challan_number || 'Delivery Challan' }}
                    </h4>
                    <span v-if="detail?.status" class="badge rounded-pill ms-2" :class="statusBadge(detail.status)">
                        {{ detail.status.charAt(0).toUpperCase() + detail.status.slice(1) }}
                    </span>
                </div>
                <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="ti ti-x"></i>
                </button>
            </div>

            <div class="modal-body" style="padding:20px;max-height:75vh;overflow-y:auto;" v-if="detail">

                <div style="display:grid;grid-template-columns:1fr 1fr;gap:0;">
                    <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Challan No</span>
                        <span style="font-size:13px;color:#1a1d23;font-weight:500;">{{ detail.challan_number }}</span>
                    </div>
                    <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Dispatch Date</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ formatDate(detail.dispatch_date) }}</span>
                    </div>
                    <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Recipient</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.recipient?.user?.name || detail.recipient?.company_name || detail.recipient?.name || '-' }}</span>
                    </div>
                    <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Warehouse</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.warehouse?.name || '-' }}</span>
                    </div>
                    <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Reference No</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.reference_no || '-' }}</span>
                    </div>
                    <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Purpose</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.purpose || '-' }}</span>
                    </div>
                    <div style="display:flex;padding:10px 12px 10px 0;border-bottom:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Transporter</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.transporter_name || '-' }}</span>
                    </div>
                    <div style="display:flex;padding:10px 0 10px 12px;border-bottom:1px solid #f4f5f8;border-left:1px solid #f4f5f8;align-items:flex-start;gap:10px;">
                        <span style="min-width:120px;font-size:12px;font-weight:500;color:#9e9e9e;">Vehicle No</span>
                        <span style="font-size:13px;color:#1a1d23;">{{ detail.vehicle_no || '-' }}</span>
                    </div>
                </div>

                <div style="border-top:1px dashed #f0f1f5;margin:16px 0;"></div>

                <div style="font-size:11px;font-weight:700;color:#b0b7c3;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:10px;">Items</div>

                <div style="border:1px solid #f0f1f5;border-radius:8px;overflow:hidden;">
                    <table class="table table-responsive" style="margin:0;font-size:13px;">
                        <thead>
                            <tr style="background:#f8f9fb;">
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">#</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Item</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">HSN</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Qty</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Unit Price</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Tax</th>
                                <th style="font-size:11.5px;font-weight:600;padding:10px 14px;border-bottom:1px solid #f0f1f5;">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in detail.challan_items" :key="item.id">
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ index + 1 }}</td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;font-weight:500;">
                                    {{ item.item?.name || item.name }}
                                    <br><span class="text-muted" style="font-size:11px;">{{ item.item?.code || '' }}</span>
                                </td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ item.hsn_code || '-' }}</td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ item.quantity }}</td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ formatCurrency(item.unit_price) }}</td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;">{{ formatCurrency(item.tax_amount) }}</td>
                                <td style="padding:10px 14px;border-bottom:1px solid #f4f5f8;font-weight:600;">{{ formatCurrency(item.total) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style="display:flex;justify-content:flex-end;margin-top:16px;">
                    <div style="min-width:250px;">
                        <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f4f5f8;">
                            <span style="font-size:12px;color:#9e9e9e;">Subtotal</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ formatCurrency(detail.subtotal) }}</span>
                        </div>
                        <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f4f5f8;">
                            <span style="font-size:12px;color:#9e9e9e;">Tax</span>
                            <span style="font-size:13px;color:#1a1d23;">{{ formatCurrency(detail.tax_amount) }}</span>
                        </div>
                        <div style="display:flex;justify-content:space-between;padding:8px 0;">
                            <span style="font-size:13px;font-weight:700;color:#1a1d23;">Total</span>
                            <span style="font-size:14px;font-weight:700;color:#e84040;">{{ formatCurrency(detail.total) }}</span>
                        </div>
                    </div>
                </div>

            </div>

            <div v-else class="modal-body text-center p-5">
                <span class="text-muted">Loading...</span>
            </div>

        </div>
    </div>
</div>
<!-- /View Detail Modal -->

</template>